export enum EMembership {
  basic = 'basic',
  premium = 'premium',
  premium_plus = 'premium_plus',
}

export type premiumMembership = {
  minimum_amount: number;
  name: EMembership;
};
